import * as Comlink from 'comlink';
import type { RunDataWorker } from '@/app/workers/run-data/worker';

console.log('process.env', process.env.NODE_ENV);

let worker: any;
if (process.env.NODE_ENV === 'development') {
	worker = new Worker(new URL('./worker.ts', import.meta.url), {
		type: 'module',
		credentials: 'omit',
	});
} else {
	let fullDomain =
		window.location.protocol +
		'//' +
		window.location.hostname +
		(window.location.port ? ':' + window.location.port : '');
	worker = new Worker(new URL(`${fullDomain}/worker/worker.js`), {
		type: 'module',
		credentials: 'omit',
	});
}

export const runDataWorker = Comlink.wrap<RunDataWorker>(worker);
